'use strict';

function ProductActivation() {
  this.extends = [_AccountController];
  this.id = null;
  this.node = null;
  this.declaredClass = null;

  this._onFormSubmitCallback = null;
  this.formAction = 'account.edit_member';

  this.init = function () {
    this._super();
    this._$node = $(this.node);
    this._$form = this._$node.find('.js--onboarding-form')[0];

    this._onFormSubmitCallback = this.presenter.addCallbackToAction(this.formAction, this.onFormSubmittedCallback.bind(this));
  };

  this.initAllReady = function () {};

  this.destroy = function () {
    if (this._onFormSubmitCallback) {
      this.presenter.removeCallbackFromAction(this.formAction, this._onFormSubmitCallback);
    }
  };

  this.onFormSubmittedCallback = function (data, response) {
    if (data && data.errors && data.errors[0].code == 400) {
      // TODO:
      // this.analytics.pushEvent('form-errors', { FormErrors: ['Amount'] });
      $('#Notification').mogo().get();
    } else if (response === 200) {
      // TODO:
      this.presenter.models.account.updateModel(data, this.onCompletedStep.bind(this));
    } else {
      // what happen?
    }
  };

  this.onCompletedStep = function () {
    // this.presenter.setModelProperty('account.activatedProducts', 'loans'); // Phase 2: setup once BE support exists
    this.routeToNextStep(); // _OnboardingCoordinator
  };
}